<template>
    <div class="product-block">
        <div class="product-block__column">
            <h2 class="product-block__heading">{{ title }}</h2>
            <p class="body-copy">{{ description }}</p>
        </div>

        <div class="product-block__column">
            <ul class="product-block__price-list">
                <li class="product-block__price-list-item">{{ price }}</li>
                <li v-if="frequency.length > 1" class="product-block__price-list-item">{{ frequency }}</li>
            </ul>
        </div>

        <div class="product-block__column">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ProductBlock',
        props: {
            title: {
                type: String,
                required: true
            },
            description: {
                type: String,
                required: true
            },
            price: {
                type: String,
                required: true
            },
            frequency: {
                type: String,
                required: false,
                default: ''
            }
        },
    }
</script>